function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 9.66732C17.5 14.2923 14.3 18.6173 10 19.6673C5.7 18.6173 2.5 14.2923 2.5 9.66732V4.66732L10 1.33398L17.5 4.66732V9.66732ZM10 18.0006C13.125 17.1673 15.8333 13.4507 15.8333 9.85065V5.75065L10 3.15065L4.16667 5.75065V9.85065C4.16667 13.4507 6.875 17.1673 10 18.0006Z",
  className: "icon-primary"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.41683 7.16667C8.8335 6.91667 9.41683 6.75 10.1668 6.75C10.9168 6.75 11.5835 6.91667 11.9168 7.16667C12.3335 7.5 12.5835 8 12.5835 8.58333C12.5835 8.91667 12.5002 9.25 12.2502 9.58333C12.0002 9.91667 11.7502 10.1667 11.3335 10.3333C11.1668 10.5 11.0002 10.5833 10.9168 10.75C10.9168 10.9167 10.8335 11.0833 10.8335 11.3333H9.16683C9.16683 10.9167 9.25017 10.6667 9.5835 10.4167C9.75017 10.25 10.0835 10 10.5002 9.75C10.6668 9.66667 10.8335 9.5 11.0002 9.33333C11.0835 9.16667 11.1668 9 11.1668 8.75C11.1668 8.5 11.0835 8.33333 10.9168 8.16667C10.7502 8 10.5002 7.91667 10.2502 7.91667C10.0002 7.91667 9.8335 8 9.66683 8.08333C9.50017 8.16667 9.41683 8.33333 9.41683 8.58333H7.75017C7.66683 8 7.91683 7.5 8.41683 7.16667Z",
  className: "icon-primary"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.16683 13.8333V12.1667H10.8335V13.8333H9.16683Z",
  className: "icon-primary"
});

function SvgKycNotPerformedShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    className: "icon-secondary",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycNotPerformedShort);
export default __webpack_public_path__ + "static/media/kyc-not-performed-short.d40c78b7.svg";
export { ForwardRef as ReactComponent };